import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeedbackState } from './feedback.reducer';

export const selectFeedbackState = createFeatureSelector<FeedbackState>('feedback');

export const selectAllFeedback = createSelector(
  selectFeedbackState,
  (state: FeedbackState) => state.allFeedback ?? []
);
